// Copyright 2018 Sorama B.V.

import { Disposable, autoinject } from "aurelia-framework";

@autoinject
export class ResizeListener {
    public elementResizeEvent(element: Element, callback: () => void): Disposable {
        // Use native ResizeObserver for all modern browsers
        let lastReportedWidth: number = undefined;
        let lastReportedHeight: number = undefined;
        let resizeRaf: number | undefined;

        const resizeObserver = new ResizeObserver(() => {
            if (resizeRaf) {
                return;
            }

            resizeRaf = requestAnimationFrame(() => {
                resizeRaf = undefined;

                const newWidth = element.clientWidth;
                const newHeight = element.clientHeight;

                if (
                    lastReportedWidth === undefined ||
                    lastReportedHeight === undefined ||
                    Math.abs(lastReportedWidth - newWidth) >= 1 ||
                    Math.abs(lastReportedHeight - newHeight) >= 1
                ) {
                    lastReportedWidth = newWidth;
                    lastReportedHeight = newHeight;
                    callback();
                }
            });
        });

        resizeObserver.observe(element);

        return {
            dispose: () => {
                if (resizeRaf) {
                    cancelAnimationFrame(resizeRaf);
                }

                resizeObserver.unobserve(element);
                resizeObserver.disconnect();
            },
        };
    }
}
